import { render, staticRenderFns } from "./general-fields-group-panel.vue?vue&type=template&id=483a4a46&scoped=true&"
import script from "./general-fields-group-panel.vue?vue&type=script&lang=js&"
export * from "./general-fields-group-panel.vue?vue&type=script&lang=js&"
import style0 from "./general-fields-group-panel.vue?vue&type=style&index=0&id=483a4a46&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483a4a46",
  null
  
)

export default component.exports